"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSearchPage = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var UpdateSaveSearchAction_1 = require("@/pages/savesearch/actions/UpdateSaveSearchAction");
var searchSetToRow_1 = require("@/transformers/searchSetToRow");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var MemberPage_1 = require("@/pages/common/components/MemberPage");
var toUrl_1 = require("@/utils/toUrl");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { languageCode: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, languageMap: state.layout.language.languages, currencyMap: state.layout.currencies.options, sortOptions: state.hfilter.sortOptions, googleApi: state.layout.googleApi, currentHfilter: state.hfilter, currentLayoutState: state.layout, typeOptions: state.hfilter.typeOptions })); };
var mapDispatchToProps = function (dispatch) { return ({
    removeSearchSet: function (id) {
        return dispatch(UpdateSaveSearchAction_1.default.removeSearchSet(id));
    },
    onSearchSetClicked: function (searchSet) {
        return dispatch(UpdateSaveSearchAction_1.default.onSearchSetClicked(searchSet));
    },
}); };
exports.saveSearchPage = function (props) {
    var renderRow = function (name, value) {
        return (React.createElement("div", { className: "c-cardlist__body" },
            React.createElement("div", { className: "c-cardlist__bodyrow c-labelrow" },
                React.createElement("div", { className: "c-labelrow__label" }, name),
                React.createElement("div", { className: "c-labelrow__value u-caption" }, value))));
    };
    var renderDistrict = function (saveSearch, searchSet) {
        if (!searchSet.district && !searchSet.area)
            return '';
        var text = searchSetToRow_1.getDistrictRow(searchSet.area.split(',').map(function (it) { return Number(it.trim()); }), searchSet.district.split(',').map(function (it) { return Number(it.trim()); }), saveSearch.districts, saveSearch.nameAndMore);
        return renderRow(saveSearch.nameDistrict, text);
    };
    var renderLayout = function (saveSearch, searchSet, options) {
        if (!searchSet.layout)
            return '';
        var text = searchSet.layout
            .split(',')
            .map(function (it) { return Number(("" + it).trim()); })
            .map(function (it) { return options.find(function (it2) { return it2.value === it; }).name; })
            .join(', ');
        return renderRow(saveSearch.nameLayout, text);
    };
    var renderLanguage = function (props, text, languageId) {
        var defaultLanguageName = props.languageMap[0].name;
        return renderRow(text, languageId ? props.languageMap.filter(function (it) { return it.id === languageId; })[0].name : defaultLanguageName);
    };
    var renderCurrency = function (props, text, currencyId) {
        return renderRow(text, props.currencyMap.filter(function (it) { return it.key === currencyId; })[0].code);
    };
    var renderPrice = function (saveSearch, searchSet, currencyMap, props) {
        var name = saveSearch.namePrice;
        if (!searchSet.priceMin && !searchSet.priceMax)
            return;
        var value = searchSetToRow_1.getPriceRow(searchSet.priceMin, searchSet.priceMax, searchResponseToResultPage_1.listTypeIdMap[searchSet.listingTypeId], searchSet.currencyId, currencyMap, props.savesearch.nameAbove, props.savesearch.nameBelow);
        return renderRow(name, value);
    };
    var renderSize = function (saveSearch, searchSet, props) {
        if (!searchSet.sizeMin && !searchSet.sizeMax)
            return '';
        var type = searchSet.sizeType === 'G'
            ? saveSearch.nameGross
            : saveSearch.nameSaleable;
        var text = searchSetToRow_1.getSizeRow(searchSet.sizeMin, searchSet.sizeMax, saveSearch.nameFt, type, props.savesearch.nameAbove, props.savesearch.nameBelow);
        return renderRow(saveSearch.nameSize, text);
    };
    var renderBed = function (saveSearch, searchSet) {
        if (!searchSet.bedroomMin && searchSet.bedroomMax === 20)
            return;
        var text = searchSetToRow_1.getBedRow(searchSet.bedroomMin, searchSet.bedroomMax, saveSearch.nameStudio);
        return renderRow(saveSearch.nameBed, text);
    };
    var renderAmenity = function (saveSearch, searchSet) {
        var text = searchSetToRow_1.getFeatureRow(searchSet.hasMaidRoom, searchSet.hasParking, searchSet.hasOutdoorSpace, saveSearch.nameMaidRoom, saveSearch.nameCarpark, saveSearch.nameOutdoor);
        if (!text)
            return '';
        return renderRow(saveSearch.nameAmenity, text);
    };
    var renderNotification = function (saveSearch, searchSet) {
        var textKey = searchSet.notificationEnabled
            ? searchSet.notificationFrequency.toLowerCase()
            : 'off';
        return (React.createElement("div", { className: "c-cardlist__body" },
            React.createElement("div", { className: "c-cardlist__bodyrow c-labelrow" },
                React.createElement("div", { className: "c-labelrow__label" }, saveSearch.nameEmailFreq),
                React.createElement("div", null,
                    React.createElement("a", { className: "o-btn o-btn--flat", href: "./alerts" }, saveSearch.nameFreq[textKey])))));
    };
    var renderSort = function (saveSearch, searchSet, options) {
        var text = searchSetToRow_1.getSortRow(searchSet.orderBy, searchSet.sortBy, options);
        if (!text)
            return '';
        return renderRow(saveSearch.nameSort, text);
    };
    var getImage = function (saveSearchPageState, searchSet) {
        var selectedDistricts = searchSet.district ? saveSearchPageState.districts.filter(function (it) { return searchSet.district.split(',').map(function (it) { return Number(it.trim()); }).findIndex(function (it2) { return it2 === it.id; }) >= 0; }) : [];
        return GoogleMap_1.getStaticImage(selectedDistricts.length === 1 ? selectedDistricts[0] : null, props.googleApi);
    };
    // tslint:disable-next-line:max-line-length
    var renderSearchSets = function (searchSets, saveSearch, props) {
        var typeStrMap = {
            1: saveSearch.nameBuy,
            2: saveSearch.nameRent,
            3: saveSearch.nameAll,
            4: saveSearch.nameAll,
        };
        var renderSearchSet = function (searchSet, index, props) {
            var buyRent = typeStrMap[searchSet.listingTypeId];
            var removeSearchSet = function (id) {
                return function () { return props.removeSearchSet(id); };
            };
            var itemHref = toUrl_1.searchSetToUrl(searchSet, props.currentHfilter, props.currentLayoutState);
            return (React.createElement("div", { key: index, className: "js-savesearch-page-item l-gridlist__item js-placelist-item" },
                React.createElement("div", { className: "c-cardlist" },
                    React.createElement("div", { className: "c-cardlist__content" },
                        React.createElement("div", { className: "c-cardlist__flex" },
                            React.createElement("div", { className: "c-cardlist__side" },
                                React.createElement("img", { className: "o-image", src: getImage(saveSearch, searchSet) })),
                            React.createElement("div", { className: "c-cardlist__main" },
                                React.createElement("a", { href: itemHref, className: "c-cardlist__title" }, searchSet.name),
                                renderRow(saveSearch.nameType, buyRent),
                                searchSet.keyword
                                    ? renderRow(saveSearch.nameKeyword, searchSet.keyword)
                                    : '',
                                renderLayout(saveSearch, searchSet, props.typeOptions),
                                renderDistrict(saveSearch, searchSet),
                                renderPrice(saveSearch, searchSet, props.currencyMap, props),
                                renderSize(saveSearch, searchSet, props),
                                renderBed(saveSearch, searchSet),
                                renderAmenity(saveSearch, searchSet),
                                renderSort(saveSearch, searchSet, props.sortOptions),
                                renderLanguage(props, saveSearch.nameLanguage, searchSet.languageId),
                                renderCurrency(props, saveSearch.nameCurrency, searchSet.currencyId),
                                renderNotification(saveSearch, searchSet),
                                React.createElement("div", { className: "c-cardlist__action" },
                                    React.createElement("div", { className: "c-cardlist__action-item" },
                                        React.createElement("a", { href: itemHref, className: "o-btn o-btn--flat" }, saveSearch.nameViewListing)))))),
                    React.createElement("div", { className: "c-cardlist__actions" },
                        React.createElement("a", { className: "c-cardlist__action-item", onClick: removeSearchSet(searchSet.userSearchSetId) },
                            React.createElement("span", { className: "fal fa-times" }))))));
        };
        if (!searchSets || !searchSets.length) {
            var href = "/" + props.languageCode + "/property-search/buy";
            return (React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                React.createElement("div", { className: "c-jumbo__header" },
                    React.createElement("div", { className: "c-jumbo__header-main" },
                        React.createElement("div", { className: "c-jumbo__title" }, saveSearch.nameEmptyTitle),
                        React.createElement("div", { className: "c-jumbo__caption" }, saveSearch.nameEmptyCaption))),
                React.createElement("div", { className: "c-jumbo__body" },
                    React.createElement("div", { className: "c-jumbo__content" },
                        React.createElement("div", { className: "c-jumbo__content-row" }, saveSearch.nameEmptyStartNew)),
                    React.createElement("div", { className: "c-jumbo__actions" },
                        React.createElement("a", { href: href, className: "o-btn o-btn--primary" }, saveSearch.nameEmptySearchNow)))));
        }
        return searchSets.map(function (it, index) {
            return renderSearchSet(it, index, props);
        });
    };
    var renderSaveSearch = function (props) {
        var searchSets = props.savesearch.searchSets;
        return (React.createElement("div", { id: "savesearch-page", className: "l-container__main", style: { maxWidth: 'none' } },
            React.createElement("div", { className: "l-pad-content" },
                React.createElement("div", { className: "c-page-header c-page-header--center-mobile" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.savesearch.nameTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.savesearch.nameCaption))),
                React.createElement("div", { className: "l-gridlist js-gridlist l-gridlist--list-nopad" },
                    React.createElement("div", { className: "l-gridlist__body " }, renderSearchSets(searchSets, props.savesearch, props)))),
            React.createElement(Megafoot_1.default, null)));
    };
    return React.createElement(MemberPage_1.default, null, renderSaveSearch(props));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.saveSearchPage);
